import { EventEmitter } from 'eventemitter3'
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
// @ts-ignore
import ConfirmModal from '../ConfirmModal.vue'
// @ts-ignore
import { WithConfirmModal } from './with-confirm-modal'

export class ConfirmModalState {
  static initial(key: string): ConfirmModalState {
    return new ConfirmModalState(key, false)
  }
  constructor(
    public readonly key: string,
    public isConfirming: boolean,
    public readonly confirmEventEmitter = new EventEmitter()
  ) {}
}

/**
 * 一つのVueコンポーネントで複数のConfirmModalコンポーネントを扱うための状態管理用ミックスイン。
 * 一般に同じユーザ操作やイベントに対してメッセージの内容をそのときの状況に応じて可変的にしたいだけであれば、単一のConfirmModalコンポーネントを使い回すだけでよい。
 * それを超えて、複独立した意味や変更ライフサイクルを持つユースケースに対応した複数のConfirmModalコンポーネントをを扱えるようにしたのがこのミックスインである。
 *
 * ConfirmModalコンポーネントの状態隊管理用ミックスイン WithConfirmModal は、一つのコンポーネントで一つのモーダルしか扱えない。
 * コンポーネントの方は同じく ConfirmModal のままでよい。
 * 将来的には既存の WithConfirmModalはこちらに、あるいはより汎用的なモーダルが整備されればそちらへと、統合されることを想定している。
 * いったん影響範囲を限定するため、WithConfirmModalとは別のミックスインを立てている。
 * @see ConfirmModal
 * @see WithConfirmModal
 */
@Mixin
export class WithMultipleConfirmModal extends Vue {
  /**
   * ミックスイン先内部で初期値を固有の状態として定義・上書きすること。
   */
  protected multipleConfirmModalState: ConfirmModalState[] = []

  isConfirming(key: string): boolean {
    return this.find(key).isConfirming
  }

  confirm(key: string): Promise<boolean> {
    const state = this.find(key)
    state.isConfirming = true

    return new Promise((resolve) => {
      state.confirmEventEmitter.once('selected', (res: boolean) => {
        resolve(res)

        state.isConfirming = false
      })
    })
  }

  onConfirmModalOk(key: string) {
    this.find(key).confirmEventEmitter.emit('selected', true)
  }
  onConfirmModalCancel(key: string) {
    this.find(key).confirmEventEmitter.emit('selected', false)
  }

  private find(key: string): ConfirmModalState {
    const state = this.multipleConfirmModalState.find(s => s.key === key)

    if (state === undefined) throw new Error(`key: ${key} is not found`)

    return state
  }
}
